import { PricingTypeDisplay } from '~/constants';
import { display } from '~/utils/displayValues/common';
import { Project } from '~/types/project';

export default function pricingType(project: Project, projectState: any) {
  const pricingTypeDisplay = projectState?.isEpcOperating ? 'Project acquisition' : PricingTypeDisplay[project?.pricingType];
  return display(pricingTypeDisplay ?? '');
}